module.exports = __webpack_public_path__ + "static/img/5.e4479df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/eng/5.png
// module id = +yW2
// module chunks = 0